import { moduleStore, components, componentMap } from '@kk-activity-factory/app-components-list';

import { initKKActivityFactory } from './index';

const nonConfigurableComponentMap = {};

function testModuleSpecificIdentificationReg(str: string) {
    const regList: Array<RegExp> = []; // 这个数组中存放需要匹配的一次性开发模块
    let result = false;
    // eslint-disable-next-line sonarjs/no-empty-collection
    regList.forEach((reg) => {
        if (reg.test(str)) {
            result = true;
        }
    });
    return result;
}

/**
 * 初始化标准的活动工厂
 */
export function initDefalutKKActivityFactory() {
    return initKKActivityFactory(moduleStore, components, componentMap, {
        nonConfigurableComponentMap,
        testModuleSpecificIdentificationReg,
    });
}
